import React, { useContext, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import { UserContext } from "../../reuseableComponents/auth/UserContext";
import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import { LOAD_FILE_UPLOAD_REVIEW_DATA } from "../../../queries/archiveQrys/secureQrys/fileUploadMgmtQrys";
import FileUploadReviewForm from "./FileUploadReviewForm";
import { appConfig } from "../../../configuration/AppConfig";

const FileUploadReviewPage = (props) => {
  const { item } = props.location.state;
  const { user } = useContext(UserContext);
  const [s3Error, setS3Error] = useState(null);
  const bucketName = appConfig.bucketName;

  const { loading, error, data } = useQuery(LOAD_FILE_UPLOAD_REVIEW_DATA);

  async function handleFileDownload(fileDetails) {
    //Check file size
    if (fileDetails.fileSize >= 5 * 1024 * 1024) {
      await fetch(`${appConfig.s3GetPresignedUrl}?fileName=${fileDetails.filePath}&bucketName=${bucketName}`)
        .then((res) => res.json())
        .then((data) => window.open(data.url, "_blank").focus());
    } else {
      await fetch(`${appConfig.s3FileDownload}?fileName=${fileDetails.filePath}&bucketName=${bucketName}`).then(
        (response) => {
          if (response.status === 200) {
            response.blob().then((myBlob) => {
              const objectURL = URL.createObjectURL(myBlob);
              const link = document.createElement("a");
              link.href = objectURL;
              link.setAttribute("download", fileDetails.fileName);
              document.body.appendChild(link);
              link.click();
            });
          } else {
            response.json().then((data) => {
              setS3Error("ERROR: " + JSON.stringify(data["message"]));
            });
          }
        }
      );
    }
  }
  if (loading) {
    return (
      <>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
              <h3 style={{ color: "#fff" }}>File Upload Management</h3>
            </HeaderBox>
          </Col>
        </Row>
        {item ? (
          <>
            <Row>
              <Col>
                <br />
                <span>
                  <b>Submitted:</b> {item.createdBy} on {convertTimeStampToDate(item.createdOn)}
                </span>
                <br />
                <span>
                  <b>Document: </b>
                </span>
                <span
                  className='text-decoration-underline'
                  onClick={(evt) => handleFileDownload(item)}
                  style={{ cursor: "pointer" }}
                >
                  {item.fileName}
                </span>
                <br />
                <span>
                  <b>Reason for Upload: </b> {item.fileDescription}
                </span>
                <br />
              </Col>
            </Row>
            <Row>
              <Col>
                <span className='error'>{s3Error}</span>
              </Col>
            </Row>
          </>
        ) : (
          ""
        )}
        <br />
        <Row>
          <Col>
            <SkeletonLoader width='100%' />
          </Col>
        </Row>
      </>
    );
  }
  if (error) {
    return (
      <>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
              <h3 style={{ color: "#fff" }}>File Upload Management</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorHandler error={error} />
          </Col>
        </Row>
      </>
    );
  }

  return (
    <>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
            <h3 style={{ color: "#fff" }}>File Upload Management</h3>
          </HeaderBox>
        </Col>
      </Row>
      {item ? (
        <>
          <Row>
            <Col>
              <span>
                <b>Submitted:</b> {item.createdBy} on {convertTimeStampToDate(item.createdOn)}
              </span>
              <br />
              <span>
                <b>Document Name: </b>
              </span>
              <span
                className='text-decoration-underline'
                onClick={(evt) => handleFileDownload(item)}
                style={{ cursor: "pointer" }}
              >
                {item.fileName}
              </span>
              <br />
              <span>
                <b>Reason for Upload: </b> {item.fileDescription}
              </span>
              <br />
              <br />
            </Col>
          </Row>
          <Row>
            <Col>
              <span className='error'>{s3Error}</span>
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      <Row>
        <Col>
          <FileUploadReviewForm
            user={user}
            fileMetadata={item}
            systems={data.getWaterSystemMenu}
            fileTypes={data.getFileUploadFileTypes}
            subTypes={data.getListofDocSubTypesForDropdown}
            status={data.getAcceptRejectPending}
          />
        </Col>
      </Row>
    </>
  );
};

export default FileUploadReviewPage;
